import { makeCheckedRequest } from './requestExecutor/make-checked-request';
import type { IRequestOptions } from './types';

interface IGetRawRequestParams {
  path: string;
  options?: IRequestOptions;
}

export async function getRawRequest({ path, options }: IGetRawRequestParams): Promise<Response> {
  return makeCheckedRequest({ method: 'GET', path, options });
}
